import { generateTokens, validatePatchTokens } from './token/index';
import { compose } from './laxer/index';
import inferenceAst from './inference';
import { IAstOptions } from './index.d';
export { getTokens, getSpecialTokens } from './token/get-special-token';
import { getTokens, getSpecialTokens } from './token/get-special-token';

import Selector from './declarations/Selector';
import SelectorValue from './declarations/SelectorValue';

import { validateAstNode } from '../ast/laxer/validateAstNode';

import { transformToDSL } from './helpers/transform-to-dsl';
export { transformToDSL } from './helpers/transform-to-dsl';
export { transformTokensToDSL } from './helpers/transform-to-dsl';
import { transformFunctionsToString, transformDeclarationsToString } from '../helpers/transforms';

export { getFunctionArgumentPositions } from './helpers/get-function-argument-position';


export const SelectorDeclaration = Selector;
export const SelectorValueDeclaration = SelectorValue;


export function inference(input: string, options: IAstOptions) {
  try {
    const astOptions = options;
    const tokens = generateTokens(input, astOptions);

    // console.log(tokens);

    validatePatchTokens(tokens, astOptions);

    const ast = compose(tokens);

    validateAstNode(ast, null);
    // console.log(ast);
    // console.log(validateAstNode(ast));


    const inferencedResult = inferenceAst(ast)!;

    // console.log(inferencedResult);

    return inferencedResult || {};

  } catch (err) {
    throw err;
  }
}

export default inference;


/**
 * 类型推导生成器
 * 提供推导缓存功能
 */
export class InferenceGenerator {
  private caches: {
    [key: string]: ReturnType<typeof inference>
  } = {};

  constructor(public options: IAstOptions) {
    this.options.functions = transformFunctionsToString(options.functions);
    this.options.declarations = transformDeclarationsToString(options.declarations);
  }

  public updateOptions(patch: Partial<IAstOptions>) {

    if (patch.functions) {
      patch.functions = transformFunctionsToString(patch.functions);
    }

    if (patch.declarations) {
      patch.declarations = transformDeclarationsToString(patch.declarations);
    }

    Object.assign(this.options, patch);
    this.clearCache();
  }

  public inference(input: string) {
    // 去除首尾空格作为Key值
    const key = input.trim();

    if (this.caches[key]) {
      return this.caches[key];
    }

    try {
      const result = inference(input, this.options);

      this.caches[key] = result;

      return result;
    } catch (err) {
      delete this.caches[key];
      throw err;
    }
  }

  public getTokens(input: string) {
    return getTokens(input, this.options);
  }

  public getSpecialTokens(input: string) {
    return getSpecialTokens(input, this.options);
  }

  /**
   * 将表达式转为 dsl
   * @param input 表达式
   */
  public transformToDSL(input: string) {
    return transformToDSL(input, this.options);
  }

  public clearCache() {
    this.caches = {};
  }

  public removeCache(key: string) {
    delete this.caches[key];
  }

  public getCaches() {
    return this.caches;
  }
}
